import React, { useState, useEffect } from 'react';
import { Icon } from 'semantic-ui-react';
import { TEMAS, MODOS, lerPreferencias, salvarPreferencias } from '../../../utils/tema';

const CORES_PREVIA = {
  rosa: { principal: '#e83c6e', lado: '#fdf0f4' },
  azul: { principal: '#2563eb', lado: '#eff4ff' },
  grafite: { principal: '#334155', lado: '#eef1f5' },
};

// Escolha de aparência: 3 temas de cor e o modo claro/escuro (o tema Grafite não tem modo escuro).
const Aparencia = () => {
  const [prefs, setPrefs] = useState(lerPreferencias());
  const temaAtual = TEMAS.find(t => t.chave === prefs.tema);

  // acompanha mudanças feitas pelo seletor do menu superior
  useEffect(() => {
    const atualizar = e => setPrefs(e.detail);
    window.addEventListener('va-tema-alterado', atualizar);
    return () => window.removeEventListener('va-tema-alterado', atualizar);
  }, []);

  const alterar = parcial => {
    const novas = { ...prefs, ...parcial };
    setPrefs(novas);
    salvarPreferencias(novas);
  };

  return (
    <div>
      <h3 className="va-perfil-titulo"><Icon name="paint brush" /> Tema do sistema</h3>
      <p className="va-perfil-ajuda">Escolha a cor do sistema. A preferência fica salva neste navegador.</p>

      <div className="va-tema-grade" role="radiogroup" aria-label="Tema">
        {TEMAS.map(tema => {
          const cor = CORES_PREVIA[tema.chave];
          return (
            <button
              type="button"
              key={tema.chave}
              role="radio"
              aria-checked={prefs.tema === tema.chave}
              className={`va-tema-opcao ${prefs.tema === tema.chave ? 'ativo' : ''}`}
              onClick={() => alterar({ tema: tema.chave })}
            >
              <span className="va-tema-marca"><Icon name="check" /></span>
              <div className="va-tema-previa" aria-hidden="true">
                <i className="lado" style={{ background: cor.lado }}>
                  <b style={{ background: cor.principal, width: '80%' }} />
                  <b style={{ background: cor.principal, opacity: .35 }} />
                  <b style={{ background: cor.principal, opacity: .35 }} />
                </i>
                <i className="corpo" style={{ background: '#fff' }}>
                  <b style={{ background: '#d9dde6' }} />
                  <em style={{ background: cor.principal }} />
                </i>
              </div>
              <h4>{tema.nome}</h4>
              <small>{tema.descricao}</small>
            </button>
          );
        })}
      </div>

      <h3 className="va-perfil-titulo"><Icon name="adjust" /> Modo</h3>
      <p className="va-perfil-ajuda">Claro, escuro ou automático (acompanha a configuração do seu computador ou celular).</p>
      <div className="va-modo-grupo" role="radiogroup" aria-label="Modo">
        {MODOS.map(modo => (
          <button
            type="button"
            key={modo.chave}
            role="radio"
            aria-checked={prefs.modo === modo.chave}
            className={prefs.modo === modo.chave ? 'ativo' : ''}
            disabled={!temaAtual.escuro}
            onClick={() => alterar({ modo: modo.chave })}
          >
            {modo.nome}
          </button>
        ))}
      </div>
      {!temaAtual.escuro && (
        <p className="va-tema-nota"><Icon name="info circle" /> O tema {temaAtual.nome} não tem modo escuro e sempre usa o modo claro.</p>
      )}
    </div>
  );
};

export default Aparencia;
